
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { EquipmentViewComponent } from './equipment-view/equipment-view.component';

const routes: Routes = [
    {
        path: '',
        data: {
            title: 'Equipment',
          },
        component: EquipmentViewComponent
        
    }
]

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class EquipmentRoutingModule { }